
















































import { AuthStoreHelper } from '../../core/mixins';
import { Component, Emit, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import {
    PlayBackInfo,
    PlaybackState,
    mapFromRangeToRange,
    getDateFromDateFormatApi,
    getStringTimeFromDate
} from '../../core/utils';
import CardPlayBackInfo from './CardPlayBackInfo.vue';

@Component({
    components: { CardPlayBackInfo }
})
export default class TravelInterval extends Mixins(AuthStoreHelper) {
    speed: number = 50;
    @Prop() state: string;
    @Prop() playBackInfos: Record<string, PlayBackInfo>;
    @Prop() timeStampInfo: string | undefined;

    get date() {
        return this.timeStampInfo ? getDateFromDateFormatApi(this.timeStampInfo) : null;
    }

    get getGTMPlayPauseButtons() {
        if (!this.$store.state.userGroupSmartway) {
            return this.state === 'play' ? 'ga_btn_tracking_playback_pause' : 'ga_btn_tracking_playback_play';
        } else {
            return '';
        }
    }

    getGTMClasses(button) {
        if (!this.$store.state.userGroupSmartway) {
            switch (button) {
                case 1:
                    return 'ga_btn_tracking_playback_stop';
                case 2:
                    return 'ga_btn_tracking_playback_reduce_speed_button';
                case 3:
                    return 'ga_btn_tracking_playback_increase_speed_button';
            }
        }
    }

    @Watch('speed')
    observableSpeed(value: number) {
        let maxSpeed = 20; //current max speed, interval between frames in ms
        let minSpeed = 500;

        //speed is in ms (time between frames)
        let speed = mapFromRangeToRange(value, 100, 0, maxSpeed, minSpeed);

        if (value == 0) {
            //if input value is 0, don't move
            this.changeSpeed(10000000000000);
        } else {
            this.changeSpeed(speed);
        }
    }

    getTimestamp(date) {
        return getStringTimeFromDate(date);
    }
    handleReduceSpeed() {
        this.speed -= 10;
        if (this.speed < 0) {
            this.speed = 0;
        }
    }

    handleAddSpeed() {
        this.speed += 10;
        if (this.speed > 100) {
            this.speed = 100;
        }
    }

    handleStop() {
        this.changeSate(PlaybackState.STOP);
    }

    handlePause() {
        this.changeSate(PlaybackState.PAUSE);
    }

    handlePlay() {
        this.changeSate(PlaybackState.PLAY);
    }

    handlePlayPause() {
        if (this.state === PlaybackState.PLAY) {
            this.changeSate(PlaybackState.PAUSE);
        } else {
            this.changeSate(PlaybackState.PLAY);
        }
    }

    @Emit()
    changeSate(value: string) {
        return value;
    }

    @Emit()
    changeSpeed(value: number) {
        return value;
    }
}
